import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/connectors',
    name: RouteName.Connectors,
    component: () => import('@/pages/Connectors/ConnectorList.vue'),
    meta: {
      permissions: [CRMPermission.Connectors],
      breadcrumb: {
        label: 'Коннекторы',
        parent: RouteName.Settings,
      },
    },
  },
  {
    path: '/connectors/create',
    name: 'connector-create',
    component: () => import('@/pages/Connectors/ConnectorForm.vue'),
    meta: {
      permissions: [CRMPermission.Connectors],
      breadcrumb: {
        label: 'Новый коннектор',
        parent: RouteName.Connectors,
      },
    },
  },
  {
    path: '/connectors/:id',
    name: 'connector-edit',
    component: () => import('@/pages/Connectors/ConnectorForm.vue'),
    props: { isEdit: false },
    meta: {
      permissions: [CRMPermission.Connectors],
      breadcrumb: {
        label: 'Редактирование коннектора',
        parent: RouteName.Connectors,
      },
    },
  },
]
